// extracted by mini-css-extract-plugin
export default {"form":"LoginPage_form__5rM2p","errorbox":"LoginPage_errorbox__8CPqd","errortext":"LoginPage_errortext__Wk9NS"};